import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "./style/Nav.css"

export default function Nav() {
    const navigate = useNavigate()
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [userName, setUserName] = useState('')
    const [shopPic, setShopPic] = useState('')
    const [isShopCreated, setIsShopCreated] = useState(false)

    useEffect(() => {
        // Check if user is logged in
        const token = localStorage.getItem('token')
        if (token) {
            setIsLoggedIn(true)
            // Get user data from localStorage
            const userData = localStorage.getItem('shop')
            if (userData) {
                try {
                    const user = JSON.parse(userData)
                    setUserName(user.shopName || 'User')
                    setShopPic(user.image || '')
                    // Check if shop is created (has shop name)
                    if (user.shopName && user.shopName.trim() !== '') {
                        setIsShopCreated(true)
                    }
                } catch (error) {
                    console.error('Error parsing user data:', error)
                }
            }
        } else {
            setIsLoggedIn(false)
            setIsShopCreated(false)
        }
    }, [])

    // Function to handle shop navigation
    const handleShopClick = () => {
        if (isShopCreated) {
            // Navigate to shop page if shop exists
            navigate('/allproducts')
        } else {
            // Navigate to create shop page if no shop
            navigate('/create-shop')
        }
    }

    return (
        <div className='nav'>
            <h1> <span>Shops</span>MK</h1>
            <div className="nav-right">
                {isLoggedIn ? (
                    <>
                        <div className="user-info">
                            {/* {shopPic && (
                                <img 
                                    src={`http://localhost:3000/uploads/${shopPic}`} 
                                    alt="Shop" 
                                    className="shop-avatar"
                                    onError={(e) => {
                                        e.target.onerror = null
                                        e.target.src = '/default-avatar.png'
                                    }}
                                />
                            )} */}
                            <span className="user-greeting">👋 Welcome, {userName}</span>
                        </div>
                        <button onClick={handleShopClick} className="shop-btn">
                            {isShopCreated ? 'My Shop' : 'Create Shop'}
                        </button>
                    </>
                ) : (
                    <button className="login-btn">
                        <Link to="/login">Login</Link>
                    </button>
                )}
            </div>
        </div>
    )
}